import React, { useState } from 'react'
import {
  Icon,
  Popup
} from 'semantic-ui-react'
import { startOfDay } from 'date-fns'
import DatePicker from 'react-datepicker'
// Styling
import './datePickerIcon.css'

/**
 * Not intended for use outside of DatePickerWidget
 *
 * Provides the date picker custom input. The onClick callback property is
 * provided by the DatePicker widget
 */

type DatePickerCustomInputProps = any

export function DatePickerCustomInput(
  props: DatePickerCustomInputProps
) {
  const {
    iconName: iconNameProp,
    iconColor: iconColorProp,
    popupContent: popupContentProp,
    mouseDelay: mouseDelayProp,
    onClick: onClickProp
  } = props
  const iconName = iconNameProp
  const iconColor = iconColorProp
  const popupContent = popupContentProp
  const mouseDelay = mouseDelayProp
  return (
    <Popup
      content={ popupContent }
      mouseEnterDelay={ mouseDelay }
      trigger={
        <Icon
          size="large"
          className="pointer"
          name={ iconName }
          color={ iconColor }
          onClick={ onClickProp }
        />
      }
    />
  )
}

/**
 * Provides a date picker widget that displays with a custom input that is an
 * Icon inside of a Popup. Ideal for use in toolbars.
 *
 * @param onSelect Callback function triggered on date select.
 *        Argument: date with time set at start of day
 * @param startDate Default: Today. Override start date with instance of Date
 * @param iconName Default: calendar. Override the icon
 * @param iconColor Default: null. Override icon color
 * @param popperClassName Default: null. Adds style overrides to the popper.
 *        Useful for adjusting placement. See datePickerIcon.scss
 * @param popupContent Default: 'Select a Date'. Override popup content
 * @param mouseDelay Default: 1000. Override MS to delay popup
 */
type DatePickerIconProps = any

export function DatePickerIcon(
  props: DatePickerIconProps
) {
  const {
    onSelect: onSelectProp,
    stateDate: startDateProp,
    iconName: iconNameProp,
    iconColor: iconColorProp,
    popupContent: popupContentProp,
    mouseDelay: mouseDelayProp,
    popperClassName: popperClassNameProp
  } = props
  const [
    startDateState,
    setStartDateState
  ] = useState(startDateProp || new Date())

  const handleChange = (
    value: Date | null
  ) => {
    const date = startOfDay(String(value))
    setStartDateState(date)
    onSelectProp(date)
  }

  const iconName = iconNameProp || 'calendar'
  const iconColor = iconColorProp || 'grey'
  const popupContent = popupContentProp || 'Select a Date'
  const mouseDelay = mouseDelayProp || 1000
  const popperClassName = popperClassNameProp || null

  return (
    <DatePicker
      popperClassName={ popperClassName }
      customInput={
        <DatePickerCustomInput
          iconName={ iconName }
          iconColor={ iconColor }
          popupContent={ popupContent }
          mouseDelay={ mouseDelay }
        />
      }
      selected={ startDateState }
      onChange={ handleChange }
    />
  )
}

export default {
  DatePickerIcon,
  DatePickerCustomInput
}
